package com.eladfinish.bible.contest

import dev.icerock.moko.resources.FileResource
import kotlin.collections.List

internal object CommonMainFiles0 {
  internal val correct_answer_bell_gliss_mp3: FileResource by lazy {
      init_correct_answer_bell_gliss_mp3() }

  internal val correct_answer_double_mp3: FileResource by lazy { init_correct_answer_double_mp3() }

  internal val correct_answer_wav: FileResource by lazy { init_correct_answer_wav() }

  internal val ic_launcher_web_png: FileResource by lazy { init_ic_launcher_web_png() }

  internal val key1_pressed_mp3: FileResource by lazy { init_key1_pressed_mp3() }

  internal val key2_pressed_mp3: FileResource by lazy { init_key2_pressed_mp3() }

  internal val key_backspace_pressed_mp3: FileResource by lazy { init_key_backspace_pressed_mp3() }

  internal val little_rainy_seasons_correct_mp3: FileResource by lazy {
      init_little_rainy_seasons_correct_mp3() }

  internal val neck_snap_mp3: FileResource by lazy { init_neck_snap_mp3() }

  internal val old_correct_answer_wav: FileResource by lazy { init_old_correct_answer_wav() }

  internal val page_turning_mp3: FileResource by lazy { init_page_turning_mp3() }

  internal val remove_ads_icon_png: FileResource by lazy { init_remove_ads_icon_png() }

  internal val roll_dice_mp3: FileResource by lazy { init_roll_dice_mp3() }

  internal val wrong_answer_wav: FileResource by lazy { init_wrong_answer_wav() }

  internal fun values(): List<FileResource> = listOf(correct_answer_bell_gliss_mp3,
      correct_answer_double_mp3, correct_answer_wav, ic_launcher_web_png, key1_pressed_mp3,
      key2_pressed_mp3, key_backspace_pressed_mp3, little_rainy_seasons_correct_mp3, neck_snap_mp3,
      old_correct_answer_wav, page_turning_mp3, remove_ads_icon_png, roll_dice_mp3,
      wrong_answer_wav)
}

private fun init_correct_answer_bell_gliss_mp3(): FileResource = FileResource(fileUrl =
    js("require(\"./files/correct_answer_bell_gliss.mp3\")") as String)

private fun init_correct_answer_double_mp3(): FileResource = FileResource(fileUrl =
    js("require(\"./files/correct_answer_double.mp3\")") as String)

private fun init_correct_answer_wav(): FileResource = FileResource(fileUrl =
    js("require(\"./files/correct_answer.wav\")") as String)

private fun init_ic_launcher_web_png(): FileResource = FileResource(fileUrl =
    js("require(\"./files/ic_launcher-web.png\")") as String)

private fun init_key1_pressed_mp3(): FileResource = FileResource(fileUrl =
    js("require(\"./files/key1_pressed.mp3\")") as String)

private fun init_key2_pressed_mp3(): FileResource = FileResource(fileUrl =
    js("require(\"./files/key2_pressed.mp3\")") as String)

private fun init_key_backspace_pressed_mp3(): FileResource = FileResource(fileUrl =
    js("require(\"./files/key_backspace_pressed.mp3\")") as String)

private fun init_little_rainy_seasons_correct_mp3(): FileResource = FileResource(fileUrl =
    js("require(\"./files/little_rainy_seasons_correct.mp3\")") as String)

private fun init_neck_snap_mp3(): FileResource = FileResource(fileUrl =
    js("require(\"./files/neck_snap.mp3\")") as String)

private fun init_old_correct_answer_wav(): FileResource = FileResource(fileUrl =
    js("require(\"./files/old_correct_answer.wav\")") as String)

private fun init_page_turning_mp3(): FileResource = FileResource(fileUrl =
    js("require(\"./files/page_turning.mp3\")") as String)

private fun init_remove_ads_icon_png(): FileResource = FileResource(fileUrl =
    js("require(\"./files/remove_ads_icon.png\")") as String)

private fun init_roll_dice_mp3(): FileResource = FileResource(fileUrl =
    js("require(\"./files/roll_dice.mp3\")") as String)

private fun init_wrong_answer_wav(): FileResource = FileResource(fileUrl =
    js("require(\"./files/wrong_answer.wav\")") as String)

public actual val SharedRes.files.correct_answer_bell_gliss_mp3: FileResource
  get() = CommonMainFiles0.correct_answer_bell_gliss_mp3

public actual val SharedRes.files.correct_answer_double_mp3: FileResource
  get() = CommonMainFiles0.correct_answer_double_mp3

public actual val SharedRes.files.correct_answer_wav: FileResource
  get() = CommonMainFiles0.correct_answer_wav

public actual val SharedRes.files.ic_launcher_web_png: FileResource
  get() = CommonMainFiles0.ic_launcher_web_png

public actual val SharedRes.files.key1_pressed_mp3: FileResource
  get() = CommonMainFiles0.key1_pressed_mp3

public actual val SharedRes.files.key2_pressed_mp3: FileResource
  get() = CommonMainFiles0.key2_pressed_mp3

public actual val SharedRes.files.key_backspace_pressed_mp3: FileResource
  get() = CommonMainFiles0.key_backspace_pressed_mp3

public actual val SharedRes.files.little_rainy_seasons_correct_mp3: FileResource
  get() = CommonMainFiles0.little_rainy_seasons_correct_mp3

public actual val SharedRes.files.neck_snap_mp3: FileResource
  get() = CommonMainFiles0.neck_snap_mp3

public actual val SharedRes.files.old_correct_answer_wav: FileResource
  get() = CommonMainFiles0.old_correct_answer_wav

public actual val SharedRes.files.page_turning_mp3: FileResource
  get() = CommonMainFiles0.page_turning_mp3

public actual val SharedRes.files.remove_ads_icon_png: FileResource
  get() = CommonMainFiles0.remove_ads_icon_png

public actual val SharedRes.files.roll_dice_mp3: FileResource
  get() = CommonMainFiles0.roll_dice_mp3

public actual val SharedRes.files.wrong_answer_wav: FileResource
  get() = CommonMainFiles0.wrong_answer_wav
